export const DEV_ENVIRONMENTS = ["development", "local"]
